import { format } from 'date-fns';


export const dateFormat = (date) => {
    return format(new Date(date), 'dd-MM-yyyy HH:mm')
}

export const dateFormatmicroSecond = (date) => {
    // remove microseconds beyond 3 digits
    const fixed = date.replace(/(\.\d{3})\d+Z$/, "$1Z");
    return format(new Date(fixed), 'dd-MM-yyyy HH:mm');
};
